// This file is auto-generated, any changes you make may be overridden
// You should use src/mercuryWebCompat/pages/Treasury/Onboarding/utils.ts to access these values
import {type GeneratedCusip, type TreasuryOnboardingData} from './types'
import {Day} from '~/utils/Calendar'

export const generatedPortfolioData: Record<
  GeneratedCusip | '4812C2734',
  TreasuryOnboardingData
> = {
  // Morgan Stanley MULSX
  '617455696': {
    fundSize: `$13.6B`,
    maturity: `82 days`,
    netYieldPct: 3.674,
    grossYieldPct: 4.54,
    mercuryFeePct: 0.866,
    composition: [
      ['Corporate Notes', 36.42],
      ['Commercial Paper', 29.59],
      ['Repurchase Agreements', 17.77],
      ['Certificates of Deposit', 16.22],
    ],
    updatedAt: new Day(2025, 5, 12),
  },
  // Vanguard VUSXX
  '921932109': {
    fundSize: `$91.9 B`,
    maturity: `42 days`,
    netYieldPct: 3.364,
    grossYieldPct: 4.23,
    mercuryFeePct: 0.866,
    composition: [
      ['U.S. Treasury Bills', 96.7],
      ['U.S. Govt. Obligations', 3.3],
    ],
    updatedAt: new Day(2025, 5, 12),
  },
  // JPMorgan IJTXX
  '4812C2734': {
    fundSize: `$45.64B`,
    maturity: `51 days`,
    netYieldPct: 3.354,
    grossYieldPct: 4.22,
    mercuryFeePct: 0.866,
    composition: [
      ['U.S. Treasury Debt', 55.6],
      ['U.S. Treasury Repurchase Agreement', 44.4],
    ],
    updatedAt: new Day(2025, 5, 12),
  },
} as const
